module.exports = __webpack_public_path__ + "static/media/chart-spline.a47b9c81.svg";